export default __webpack_public_path__ + "static/media/Oakstand.35c56341.jpg";